module.exports = __webpack_public_path__ + "favicon-16x16.717f0271.png";